<mat-card class="past-participation-card">
    <mat-card-header class="past-participation-header">
        <mat-card-title>Program Participation</mat-card-title>
        <mat-icon (click)="closePopup()" class="close-icon">close</mat-icon>
    </mat-card-header>

    <!-- Loader -->
    <div class="loader-container" *ngIf="loadWorkorder">
        <mat-spinner [diameter]="40"></mat-spinner>
    </div>
    <mat-card-content class="card-content-data">
        <div class="content-area">
            <div *ngIf="!isDataFound" class="program-card">
                <div class="program-header">
                    <h3 class="program-title">Summary</h3>       
                </div>            
                <div *ngFor="let program of programs" class="detail-value">
                    <!-- Main line: JobDesc, JobStatus -->
                    {{ program.JobDesc }}<span *ngIf="program?.ItemDesc">,</span>
                    <span *ngIf="program?.ItemDesc">
                        {{ program.ItemDesc.split(', ').join(', ') }}
                    </span>
                                
                </div>            
            </div>
            <div *ngFor="let program of programs" class="program-card">
                <div class="program-header">
                    <h3 class="program-title">{{ program.JobDesc }}</h3>
                    <span class="job-status-date">{{ program?.JobStatusDate | date: 'MMM d, yyyy' }}</span>
                </div>
                <div class="program-details">
                    <div class="detail-item">
                        <span class="detail-label">Account No:</span>
                        <span class="detail-value">{{ program?.AccountNo }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="detail-label">Workorder ID:</span>
                        <span class="detail-value">{{ program?.WorkorderId }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="detail-label">Job Type:</span>
                        <span class="detail-value">{{ program?.JobType }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="detail-label">Job Status:</span>
                        <span class="detail-value">{{ program?.JobStatus }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="detail-label">PremiseId:</span>
                        <span class="detail-value">{{ program?.PremiseId }}</span>
                    </div>
                </div>
                <ul class="measures-list">
                    <li *ngFor="let measure of program?.ItemDesc?.split(', ')" class="measure-item">
                        {{ measure }}
                    </li>
                </ul>
            </div>
        </div>
        <div *ngIf="isDataFound">
            <div class="no-data-message">{{isDataFound}}</div>
        </div>
    </mat-card-content>
</mat-card>